import {api} from '../../../../configs/index';
import {baseAxios} from "../../../../services/api";
import {SET_STATISTICS} from "./types";
import {setIsLoading} from "../loading/actions";

export const setStatistics = payload => dispatch => dispatch({type: SET_STATISTICS, payload});

export const getTaskBarStatistics = () => async dispatch => {

    dispatch(setIsLoading(true))

    const {data} = await baseAxios().get(api.leads.getTaskBarStatistics)

    dispatch(setIsLoading(false))

    dispatch(setStatistics(data));
}

export const getTasksGraphStatistics = params => async dispatch => {

    dispatch(setIsLoading(true))

    const {data} = await baseAxios().get(api.leads.getTasksGraphStatistics, {params})

    dispatch(setIsLoading(false))

    dispatch(setStatistics(data));
}